import { useWSModalCustom } from "@wingspanhq/fe-component-library";
import { ModalWorkDefinitionDetails } from ".";

export const useModalWorkDefinitionDetails = () =>
  useWSModalCustom(ModalWorkDefinitionDetails);
